module.exports = __webpack_public_path__ + "static/bg_vsk.f2c5a414.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_vsk.png
// module id = wtet
// module chunks = 0